import { Injectable } from '@angular/core';
import { BreakpointObserver } from '@angular/cdk/layout';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LayoutService {
  private currentScreenSize = new BehaviorSubject<boolean>(false);
  private $mobileMenuStatus = new BehaviorSubject<boolean>(false);
  mobileMenuStatus = this.$mobileMenuStatus.asObservable();
  screenObserver = this.currentScreenSize.asObservable();
  public get mobileScreen(): boolean {
    return this.currentScreenSize.value;
  }

  toggleMobileMenu(): void {
    const status = this.$mobileMenuStatus.value;
    this.$mobileMenuStatus.next(!status);
  }

  closeMobileMenu(): void {
    this.$mobileMenuStatus.next(false);
  }

  constructor(private breakpointObserver: BreakpointObserver) {
    this.init();
  }

  init(): void {
    this.breakpointObserver
      .observe(['(max-width: 768px)'])
      .subscribe((result) => {
        this.currentScreenSize.next(result.matches ?? 'false');
      });
  }
}
